import {
  UseSocialOauthProps,
  useSocialOauth as useSharedSocialOauth,
} from '@practicegenius/pg-ui/src/hooks/useSocialAuth';
import {localStorageLastUsedSocialProviderManager} from '@practicegenius/pg-ui/src/utils/lastUsedSocialProvider';
import {getWebsocket} from '../../utils/websocket';
import log from '../../utils/logger';
import {PG_CORE_URL} from '../../constants/env';

type Props = Omit<UseSocialOauthProps, 'appProps'>;

export const useSocialOauth = (props: Props) =>
  useSharedSocialOauth({
    ...props,
    appProps: {
      getWebsocket,
      lastUsedSocialProviderManager: localStorageLastUsedSocialProviderManager,
      logger: log,
      coreServiceUrl: PG_CORE_URL,
    },
  });
